import React, { useContext, useEffect, useState } from "react";
import styles from "./PaymentTransaction.module.css";
import { Button, Dialog, MenuItem, Select, TextField } from "@mui/material";
import { getApi, PostApi } from "../../Utility/network";
import { stringToYYYYMMDD } from "../../Utility/helper";
import { useLocation, useParams } from "react-router-dom";
import { AppContext } from "../../ContextApi/AppContext/AppContext";
import { consumptionEngText, consumptionGermText } from "../Pannel/Pannel";
function PaymentTransaction({ open, handleClose, data, fetchData = () => {} }) {
  const { state, setState } = useContext(AppContext);
  const { language } = state;
  const [transaction, setTransaction] = useState();
  const [dataT, setDataT] = useState({
    payment_method_id: null,
    amount: null,
    amount_captured: null,
    payment_status: null,
  });
  const location = useLocation();
  const currentConsumption = location?.pathname?.includes("/consumption");
  let { id: _id } = useParams();

  const [visible, setViasible] = useState(false);
  const [methods, setMethods] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState([
    { id: 1, title: "Pending", german_title: "Ausstehend " },
    { id: 2, title: "Paid", german_title: " Bezahlt" },
    { id: 3, title: "Unpaid", german_title: "Unbezahlt" },
    {
      id: 4,
      title: "No Payment Required",
      german_title: "Keine Zahlung erforderlich",
    },
  ]);
  const getTransaction = async (id) => {
    const url = location?.pathname.includes("consumption")
      ? `/payment/checkout?energy_consumption=${id}`
      : `/payment/checkout?energy_need=${id}`;
    try {
      const response = await getApi(url);

      setTransaction(response?.data?.data);
    } catch (error) {}
  };
  const getPaymentMethod = async () => {
    try {
      const response = await getApi(`/payment/payment_method`);

      setMethods(response?.data?.data);
    } catch (error) {}
  };
  useEffect(() => {
    getTransaction(data?.id);
    getPaymentMethod();
  }, []);
  const handleChangeINput = (e) => {
    const { name, value } = e.target;
    setDataT({
      ...dataT,
      [name]: value,
    });
  };
  const PostTransaction = async () => {
    const postdataConsumption = {
      type: 1,
      energy_consumption_id: data?.id,
      payment_method_id: dataT?.payment_method_id,
      amount: dataT?.amount,
      amount_captured: dataT?.amount_captured,
      payment_status: dataT?.payment_status,
    };
    const postdataneed = {
      type: 2,
      energy_need_id: data?.id,
      payment_method_id: dataT?.payment_method_id,
      amount: dataT?.amount,
      amount_captured: dataT?.amount_captured,
      payment_status: dataT?.payment_status,
    };
    const postdata = currentConsumption ? postdataConsumption : postdataneed;

    try {
      const response = await PostApi(`/payment/create/`, postdata);
      if(response?.status === 200 ||  response?.status === 201 || response?.status === 204){
        fetchData(_id);
        handleClose();

      }
    } catch (error) {}
  };
  return (
    <Dialog onClose={handleClose} open={open} maxWidth={"lg"}>
      <div style={{ padding: "40px", width: "950px" }}>
        <h1>
          {language == "de"
            ? consumptionGermText?.transaction_details
            : consumptionEngText?.transaction_details}
        </h1>
        {transaction?.map((item, index) => {
          return (
            <>
              <div className={styles?.detailCon} key={index}>
                <div className={styles.field}>
                  <p className={styles.head}>
                    {" "}
                    {language == "de"
                      ? consumptionGermText?.status_email
                      : consumptionEngText?.status_email}{" "}
                    :
                  </p>

                  {currentConsumption ? (
                    <p className={styles.data}>
                      {item?.energy_consumption?.email}
                    </p>
                  ) : (
                    <p className={styles.data}>{item?.energy_need?.email}</p>
                  )}
                </div>
                <div className={styles.field}>
                  <p className={styles.head}>
                    {" "}
                    {language == "de"
                      ? consumptionGermText?.date
                      : consumptionEngText?.date}{" "}
                    :
                  </p>

                  <p className={styles.data}>
                    {stringToYYYYMMDD(item?.created)}
                  </p>
                </div>
                <div className={styles.field}>
                  <p className={styles.head}>
                    {" "}
                    {language == "de"
                      ? consumptionGermText?.payment_status
                      : consumptionEngText?.payment_status}{" "}
                    :
                  </p>

                  <p className={styles.data}>{item?.payment_status_str}</p>
                </div>
                <div className={styles.field}>
                  <p className={styles.head}>
                    {" "}
                    {language == "de"
                      ? consumptionGermText?.method
                      : consumptionEngText?.method}{" "}
                    :
                  </p>

                  <p className={styles.data}>
                    {item?.payment_method?.key_name}
                  </p>
                </div>
                <div className={styles.field}>
                  <p className={styles.head}>
                    {" "}
                    {language == "de"
                      ? consumptionGermText?.transaction_id
                      : consumptionEngText?.transaction_id}{" "}
                    :
                  </p>

                  <p className={styles.data}> {item?.id}</p>
                </div>
                <div className={styles.field}>
                  <p className={styles.head}>
                    {" "}
                    {language == "de"
                      ? consumptionGermText?.amount
                      : consumptionEngText?.amount}{" "}
                    :
                  </p>

                  <p className={styles.data}> {item?.amount}</p>
                </div>
                <div className={styles.field}>
                  <p className={styles.head}>
                    {" "}
                    {language == "de"
                      ? consumptionGermText?.amount_capture
                      : consumptionEngText?.amount_capture}{" "}
                    :
                  </p>

                  <p className={styles.data}> {item?.amount_captured}</p>
                </div>
              </div>
            </>
          );
        })}
        {!visible && (
          <div className={styles.button}>
            <Button
              variant="contained"
              onClick={() => {
                setViasible(true);
              }}
            >
              {" "}
              {language == "de"
                ? consumptionGermText?.add
                : consumptionEngText?.add}{" "}
            </Button>
          </div>
        )}

        {visible && (
          <div className={styles.add}>
            <div className={styles.divide}>
              <div className={styles.FieldCon1}>
                <p className={styles.name}>
                  {language == "de"
                    ? consumptionGermText?.method
                    : consumptionEngText?.method}{" "}
                </p>

                <Select
                  sx={{ width: "100%" }}
                  size="small"
                  value={dataT?.payment_method_id}
                  name="payment_method_id"
                  onChange={(e) => {
                    handleChangeINput(e);
                  }}
                >
                  {methods?.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.title}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className={styles.FieldCon1}>
                <p className={styles.name}>
                  {" "}
                  {language == "de"
                    ? consumptionGermText?.payment_status
                    : consumptionEngText?.payment_status}{" "}
                </p>

                <Select
                  sx={{ width: "100%" }}
                  size="small"
                  value={dataT?.payment_status}
                  name="payment_status"
                  onChange={(e) => {
                    handleChangeINput(e);
                  }}
                >
                  {paymentStatus?.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {language == "de" ? option?.german_title : option.title}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>

            <div className={styles.divide}>
              <div className={styles.FieldCon1}>
                <p className={styles.name}>
                  {" "}
                  {language == "de"
                    ? consumptionGermText?.amount
                    : consumptionEngText?.amount}{" "}
                </p>

                <TextField
                  size="small"
                  value={dataT?.amount}
                  onChange={(e) => handleChangeINput(e)}
                  name="amount"
                  sx={{ width: "100%" }}
                />
              </div>
              <div className={styles.FieldCon1}>
                <p className={styles.name}>
                  {language == "de"
                    ? consumptionGermText?.amount_capture
                    : consumptionEngText?.amount_capture}{" "}
                </p>

                <TextField
                  size="small"
                  value={dataT?.amount_captured}
                  onChange={(e) => handleChangeINput(e)}
                  name="amount_captured"
                  sx={{ width: "100%" }}
                />
              </div>
            </div>
            <div className={styles.button}>
              <Button
                variant="contained"
                style={{ padding: "10px 20px" }}
                onClick={() => {
                  PostTransaction();
                }}
              >
                {" "}
                {language == "de"
                  ? consumptionGermText?.save
                  : consumptionEngText?.save}
              </Button>
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
}

export default PaymentTransaction;
